import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const api = {
  me: () => http.get("/auth/me").then((r) => r.data),
  logout: () => http.post("/auth/logout").then((r) => r.data),
  exchangeSession: (session_id) =>
    http.post("/auth/google/session", { session_id }).then((r) => r.data),
  setPersona: (persona) => http.patch("/auth/persona", { persona }).then((r) => r.data),

  questions: (persona) => http.get(`/assessment/questions/${persona}`).then((r) => r.data),
  submit: (payload) => http.post("/assessment/submit", payload).then((r) => r.data),
  latest: () => http.get("/assessment/latest").then((r) => r.data),
  myReports: () => http.get("/reports/mine").then((r) => r.data),

  jobs: (params = {}) => http.get("/jobs", { params }).then((r) => r.data),
  paths: () => http.get("/learning-paths").then((r) => r.data),
  mentors: () => http.get("/mentors").then((r) => r.data),
  market: () => http.get("/insights/market").then((r) => r.data),
  waitlist: (payload) => http.post("/waitlist", payload).then((r) => r.data),
  contact: (payload) => http.post("/contact", payload).then((r) => r.data),
};
